import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/data";

export const Services = () => {
  return (
    <section id="services" className="py-24 lg:py-40 bg-ink text-paper grain relative">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14 lg:mb-20">
          <div className="max-w-2xl">
            <span className="mono text-[10px] uppercase tracking-[0.25em] text-primary-glow">The practice</span>
            <h2 className="font-display text-3xl lg:text-5xl mt-3 leading-[1.05] tracking-[-0.02em] text-balance">
              How RCCD <em className="font-light text-paper/75">works.</em>
            </h2>
          </div>
          <p className="max-w-md text-paper/70 text-base lg:text-lg leading-relaxed">
            From first feasibility read to adopted specific plan — and into executive management for the consortia that follow.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-4 lg:gap-5 auto-rows-[minmax(260px,_auto)]">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className={`group relative overflow-hidden ${s.span} flex flex-col`}
            >
              <div className="absolute inset-0">
                <img src={s.image} alt={s.title} className="h-full w-full object-cover transition-transform duration-[1400ms] group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/65 to-ink/20" />
              </div>

              <div className="relative z-10 flex flex-col h-full p-6 lg:p-8">
                <div className="flex items-start justify-between">
                  <span className="mono text-[11px] tracking-[0.22em] text-primary-glow">{s.number}</span>
                  <ArrowUpRight className="h-5 w-5 text-paper/60 group-hover:text-paper group-hover:rotate-45 transition-all duration-500" />
                </div>

                <div className="mt-auto">
                  <div className="mono text-[10px] uppercase tracking-[0.22em] text-paper/60">{s.tagline}</div>
                  <h3 className="font-display text-3xl lg:text-5xl text-paper mt-2 leading-[0.95] tracking-[-0.02em]">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-sm lg:text-base text-paper/75 max-w-md leading-relaxed">
                    {s.description}
                  </p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {s.capabilities.map(c => (
                      <span key={c} className="mono text-[10px] uppercase tracking-[0.18em] text-paper/70 border border-paper/20 px-2.5 py-1">
                        {c}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
